export default __webpack_public_path__ + "ead226e80609d00919f37d7225dca4f8.png";